const joinArrayWithCommas = (array: unknown[]) => array.map((item) => `${item}`.toUpperCase()).join(',');

export default joinArrayWithCommas;
